<template>
  <div>
    <list-table
      url="users/userlist"
      title="لیست مشترکین"
      detailUrl="clientdetails"
      viewUrl="viewclientdetails"
      :fields="fields"
      :params="params"
    ></list-table>
  </div>
</template>
<script>
import {
    SET_BREADCRUMB
} from "@/core/services/store/breadcrumbs.module";
import httpHelper from "../../helpers/httpHelper";
import TableShowData from "../../components/table";
import UserList from "../../components/UserList";

export default {
  name: "Clients",
  data() {
    return {
      params: [
        {
          label: "از تاریخ",
          field: "datefrom",
          type: "date-picker",
        },
        {
          label: "تا تاریخ",
          field: "dateto",
          type: "date-picker",
        },
        {
          label: "نام",
          field: "fa_name",
          type: "text",
        },
        {
          label: "کد ملی",
          field: "national_card_number",
          type: "text",
        },
        {
          label: "پست الکترونیکی",
          field: "email",
          type: "text",
        },
        {
          label: "تلفن همراه",
          field: "mobile",
          type: "text",
        },
        {
          label: "نام وب سایت",
          field: "website_name",
          type: "text",
        },
        {
          label: "نوع درگاه",
          field: "select_type",
          type: "select",
          value: null,
          options: [
          {text:'همه',value:null},
          {text:'دلاری',value:1},
          {text:'ریالی',value:2},
          {text:'بدون درگاه',value:3},
          ],
        },
        {
          label: "توضیحات",
          field: "mdid119_description",
          type: "mddropdown",
          value: null,
          group:119
        },
      ],
      fields: [
        {
          key: "id",
          label: "کد",
        },
        {
          key: "fa_name",
          label: "نام و نام خانوادگی",
          formatter(value, key, item) {
            return `${item.fa_name} ${item.fa_family}`;
          },
        },
        // {
        //   key: "fa_family",
        //   label: "نام خانوادگی",
        // },
        {
          key: "email",
          label: "پست الکترونیکی",
        },
        {
          key: "mobile",
          label: "تلفن همراه",
        },
        {
          key: "national_card_number",
          label: "کد ملی",
        },
        {
          key: "phone",
          label: "تلفن ثابت",
        },
        {
          key: "pre_phone",
          label: "کد تلفن ثابت",
        },
        {
          key: "description",
          label: "توضیحات",
          formatter(value, key, item){
            return item.payment_gateways.length!==0  ? 'درخواست درگاه' : item.payment_gateways.length==0 && item.mdid119_description!==null ? item.mdid119_description.title : null ;
          },
        },
        {
          key: "details",
          label: "جزییات",
        },
      ],
    };
  },
  components: {
    "list-table": TableShowData,
    "user-list": UserList,
  },
  mounted() {
     this.$store.dispatch(SET_BREADCRUMB, [{
                    title: "صفحه اصلی",
                    route: "/dashboard"
                },
                {
                    title: "لیست مشترکین"
                }
            ]);
  },
};
</script>